const translation = {
  currentPlan: 'Planul curent',
  upgradeBtn: {
    plain: 'Actualizează planul',
    encourage: 'Actualizează acum',
    encourageShort: 'Actualizează',
  },
  viewBilling: 'Gestionează facturarea și abonamentele',
  buyPermissionDeniedTip: 'Vă rugăm să contactați administratorul dvs. de întreprindere pentru a vă abona',
  plansCommon: {
    title: 'Alegeți un plan potrivit pentru dvs.',
    yearlyTip: 'Obțineți 2 luni gratuite prin abonarea anuală!',
    mostPopular: 'Cel mai popular',
    planRange: {
      monthly: 'Lunar',
      yearly: 'Anual',
    },
    month: 'lună',
    year: 'an',
    save: 'Economisește ',
    free: 'Gratuit',
    currentPlan: 'Planul curent',
    contractSales: 'Contactați vânzările',
    contractOwner: 'Contactați managerul echipei',
    startForFree: 'Începe gratuit',
    getStartedWith: 'Începe cu ',
    contactSales: 'Contactați vânzările',
    talkToSales: 'Vorbiți cu vânzările',
    modelProviders: 'Furnizori de modele',
    teamMembers: 'Membri ai echipei',
    buildApps: 'Construiește aplicații',
    vectorSpace: 'Spațiu vectorial',
    vectorSpaceBillingTooltip: 'Fiecare 1MB poate stoca aproximativ 1,2 milioane de caractere de date vectorizate (estimat folosind OpenAI Embeddings, variază în funcție de modele).',
    vectorSpaceTooltip: 'Spațiul vectorial este sistemul de memorie pe termen lung necesar pentru ca LLM-urile să înțeleagă datele dvs.',
    documentsUploadQuota: 'Cotă de încărcare a documentelor',
    documentProcessingPriority: 'Prioritatea procesării documentelor',
    documentProcessingPriorityTip: 'Pentru o prioritate mai mare a procesării documentelor, vă rugăm să actualizați planul.',
    documentProcessingPriorityUpgrade: 'Procesați mai multe date cu o acuratețe mai mare și la viteze mai rapide.',
    priority: {
      'standard': 'Standard',
      'priority': 'Prioritate',
      'top-priority': 'Prioritate maximă',
    },
    logsHistory: 'Istoricul jurnalelor',
    customTools: 'Instrumente personalizate',
    unavailable: 'Indisponibil',
    days: 'zile',
    unlimited: 'Nelimitat',
    support: 'Asistență',
    supportItems: {
      communityForums: 'Forumuri comunitare',
      emailSupport: 'Asistență prin e-mail',
      priorityEmail: 'Asistență prioritară prin e-mail și chat',
      logoChange: 'Schimbarea logo-ului',
      SSOAuthentication: 'Autentificare SSO',
      personalizedSupport: 'Asistență personalizată',
      dedicatedAPISupport: 'Asistență API dedicată',
      customIntegration: 'Integrare și asistență personalizate',
      ragAPIRequest: 'Solicitări API RAG',
      bulkUpload: 'Încărcare în bloc a documentelor',
      agentMode: 'Mod agent',
      workflow: 'Flux de lucru',
      llmLoadingBalancing: 'Echilibrarea sarcinii LLM',
      llmLoadingBalancingTooltip: 'Adăugați mai multe chei API la modele, ocolind efectiv limitele de rată API.',
    },
    comingSoon: 'Vine în curând',
    member: 'Membru',
    memberAfter: 'Membru',
    messageRequest: {
      title: 'Credite de mesaje',
      tooltip: 'Cote de invocare a mesajelor pentru diferite planuri utilizând modele OpenAI (cu excepția gpt4). Mesajele peste limită vor utiliza cheia API OpenAI.',
      titlePerMonth: '{{count,number}} mesaje/lună',
    },
    annotatedResponse: {
      title: 'Limite de cotă de anotare',
      tooltip: 'Editarea și anotarea manuală a răspunsurilor oferă capacități de întrebări și răspunsuri personalizabile și de înaltă calitate pentru aplicații. (Aplicabil numai în aplicațiile de chat)',
    },
    ragAPIRequestTooltip: 'Se referă la numărul de apeluri API care invocă doar capacitățile de procesare a bazei de cunoștințe a Dify.',
    receiptInfo: 'Doar proprietarul echipei și administratorul echipei pot să se aboneze și să vizualizeze informațiile de facturare',
    annotationQuota: 'Cota de adnotare',
    priceTip: 'pe spațiu de lucru/',
    teamMember_one: '{{count,number}} Membru al echipei',
    unlimitedApiRate: 'Fără limită de rată API',
    freeTrialTipPrefix: 'Înscrie-te și obține un',
    self: 'Auto-găzduit',
    apiRateLimit: 'Limită de rată API',
    documentsTooltip: 'Cota pe numărul de documente importate din Sursele de Date de Cunoștințe.',
    getStarted: 'Întrebați-vă',
    cloud: 'Serviciu de cloud',
    apiRateLimitUnit: '{{count,number}}/zi',
    comparePlanAndFeatures: 'Compară planurile și caracteristicile',
    documentsRequestQuota: '{{count,number}}/min Limita de rată a cererilor de cunoștințe',
    documents: '{{count,number}} Documente de Cunoaștere',
    freeTrialTipSuffix: 'Nu este necesară o carte de credit',
    teamMember_other: '{{count,number}} membri ai echipei',
    teamWorkspace: '{{count,number}} Spațiu de lucru în echipă',
    annualBilling: 'Facturare anuala',
    freeTrialTip: 'perioadă de probă gratuită de 200 de apeluri OpenAI.',
    documentsRequestQuotaTooltip: 'Specificați numărul total de acțiuni pe care un spațiu de lucru le poate efectua pe minut în cadrul bazei de cunoștințe, inclusiv crearea, ștergerea, actualizările setului de date, încărcările de documente, modificările, arhivarea și interogările bazei de cunoștințe. Acest metric este utilizat pentru a evalua performanța cererilor din baza de cunoștințe. De exemplu, dacă un utilizator Sandbox efectuează 10 teste consecutive de hituri într-un minut, spațiul său de lucru va fi restricționat temporar de la efectuarea următoarelor acțiuni pentru minutul următor: crearea setului de date, ștergerea, actualizările și încărcările sau modificările documentelor.',
    apiRateLimitTooltip: 'Limita de rată API se aplică tuturor cererilor efectuate prin API-ul Dify, inclusiv generarea de texte, conversațiile de chat, execuțiile fluxului de lucru și procesarea documentelor.',
  },
  plans: {
    sandbox: {
      name: 'Sandbox',
      description: '200 de încercări gratuite GPT',
      includesTitle: 'Include:',
      for: 'Proba gratuită a capacităților de bază',
    },
    professional: {
      name: 'Professional',
      description: 'Pentru persoane fizice și echipe mici pentru a debloca mai multă putere la un preț accesibil.',
      includesTitle: 'Tot ce este în planul gratuit, plus:',
      for: 'Pentru dezvoltatori independenți / echipe mici',
    },
    team: {
      name: 'Echipă',
      description: 'Colaborați fără limite și bucurați-vă de performanțe de top.',
      includesTitle: 'Tot ce este în planul Professional, plus:',
      for: 'Pentru echipe de dimensiuni medii',
    },
    enterprise: {
      name: 'Întreprindere',
      description: 'Obțineți capacități și asistență complete pentru sisteme critice la scară largă.',
      includesTitle: 'Tot ce este în planul Echipă, plus:',
      features: {
        3: 'Multiple Spații de lucru și Management Enterprise',
        6: 'Securitate avansată și control',
        2: 'Funcții exclusive pentru întreprinderi',
        8: 'Asistență tehnică profesională',
        4: 'SSO',
        7: 'Actualizări și întreținere de către Dify Oficial',
        1: 'Autorizare pentru licență comercială',
        5: 'SLA-uri negociate de partenerii Dify',
        0: 'Soluții de desfășurare scalabile de nivel enterprise',
      },
      for: 'Pentru echipe de mari dimensiuni',
      price: 'Personalizat',
      priceTip: 'Facturare anuală doar',
      btnText: 'Contactați Vânzări',
    },
    community: {
      features: {
        2: 'Se conformează Licenței Open Source Dify',
        1: 'Spațiu de lucru unic',
        0: 'Toate funcțiile de bază lansate sub depozitul public',
      },
      description: 'Pentru utilizatori individuali, echipe mici sau proiecte necomerciale',
      btnText: 'Începe cu Comunitatea',
      price: 'Gratuit',
      name: 'Comunitate',
      for: 'Pentru utilizatori individuali, echipe mici sau proiecte necomerciale',
      includesTitle: 'Funcții gratuite:',
    },
    premium: {
      features: {
        1: 'Spațiu de lucru unic',
        0: 'Fiabilitate autogestionată de diferiți furnizori de cloud',
        2: 'Personalizarea logo-ului și branding-ului aplicației web',
        3: 'Suport prioritar prin email și chat',
      },
      btnText: 'Obține Premium în',
      description: 'Pentru organizații și echipe de dimensiuni medii',
      includesTitle: 'Totul din Comunitate, plus:',
      price: 'Scalabil',
      name: 'Premium',
      priceTip: 'Pe baza Pieței Cloud',
      comingSoon: 'Suport Microsoft Azure și Google Cloud în curând',
      for: 'Pentru organizații și echipe de dimensiuni medii',
    },
  },
  vectorSpace: {
    fullTip: 'Spațiul vectorial este plin.',
    fullSolution: 'Actualizați-vă planul pentru a obține mai mult spațiu.',
  },
  apps: {
    fullTipLine1: 'Actualizați-vă planul pentru a',
    fullTipLine2: 'construi mai multe aplicații.',
    fullTip2des: 'Se recomandă curățarea aplicațiilor inactive pentru a elibera resurse, sau contactați-ne.',
    fullTip2: 'Limita planului a fost atinsă',
    fullTip1des: 'Ați atins limita de aplicații construite pe acest plan',
    fullTip1: 'Upgrade pentru a crea mai multe aplicații',
    contactUs: 'Contactați-ne',
  },
  annotatedResponse: {
    fullTipLine1: 'Actualizați-vă planul pentru a',
    fullTipLine2: 'anota mai multe conversații.',
    quotaTitle: 'Cotă de răspuns anotat',
  },
  usagePage: {
    vectorSpaceTooltip: 'Documentele cu modul de indexare de calitate înaltă vor consuma resursele de stocare a datelor de cunoștințe. Când stocarea datelor de cunoștințe atinge limita, documentele noi nu vor fi încărcate.',
    buildApps: 'Construiește aplicații',
    vectorSpace: 'Stocarea datelor de cunoștințe',
    teamMembers: 'Membrii echipei',
    annotationQuota: 'Cota de Anotare',
    documentsUploadQuota: 'Cota de încărcare a documentelor',
  },
  teamMembers: 'Membrii echipei',
}

export default translation
